"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _rebrand = require("../../../../icons-react/rebrand");
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var NavigationButton = function NavigationButton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    type = _ref.type;
  return /*#__PURE__*/_react["default"].createElement(Button, {
    className: className,
    $type: type
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    $isRotated: type === 'prev'
  }));
};
var gradient = (0, _styledComponents.css)(["position:absolute;width:30px;height:", "px;top:50%;content:\"\";"], _constants.SWIPER_HEIGHT);
var Button = _styledComponents["default"].button.withConfig({
  displayName: "NavigationButton__Button",
  componentId: "sc-nr43yc-0"
})(["height:", "px;width:", "px;padding:6px;display:flex;cursor:pointer;border:none;--background-color:var(--white);background-color:var(--background-color);border-radius:var(--border-radius);:hover{background:linear-gradient(0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100%),var(--background-color);}:active{background:linear-gradient(0deg,rgba(0,0,0,var(--pressed-alpha)) 0%,rgba(0,0,0,var(--pressed-alpha)) 100%),var(--background-color);}&::before{", " ", "}"], _constants.NAV_BUTTON_SIZE, _constants.NAV_BUTTON_SIZE, gradient, function (_ref2) {
  var $type = _ref2.$type;
  console.log($type);
  switch ($type) {
    case 'prev':
      return (0, _styledComponents.css)(["background:linear-gradient(to right,var(--background) 10%,transparent);right:0;transform:translate(99%,-50%);"]);
    case 'next':
      return (0, _styledComponents.css)(["background:linear-gradient(to left,var(--background) 10%,transparent);left:0;transform:translate(-99%,-50%);"]);
  }
});
var Icon = (0, _styledComponents["default"])(_rebrand.ChevronRight).withConfig({
  displayName: "NavigationButton__Icon",
  componentId: "sc-nr43yc-1"
})(["> path{fill:var(--grey1);}", ""], function (_ref3) {
  var $isRotated = _ref3.$isRotated;
  return $isRotated && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
});
var _default = exports["default"] = NavigationButton;